import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { SsiOverviewResponse } from "./ssiAPI.types";

type SsiBaseRequestParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
  newPaymentScheduleYear: string;
};

type SsiExtendedRequestParams = SsiBaseRequestParams & {
  isoCountryCode: string;
  isoCurrencyCode: string;
};

export const ssiAPI = createApi({
  reducerPath: "ssiAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getSsiOverview: builder.query<SsiOverviewResponse, SsiExtendedRequestParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode, newPaymentScheduleYear } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Locale: locale,
          Period: period,
          NewPaymentScheduleYear: newPaymentScheduleYear,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
        });

        return `/incentives-v2/api/strong-start/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetSsiOverviewQuery } = ssiAPI;
